// ═══════════════════════════════════════════════════════════════════
//  TelemetryFlushMount — One-line invoker for useTelemetryFlush.
// ═══════════════════════════════════════════════════════════════════

import { useTelemetryFlush } from '@/hooks/useTelemetryFlush';

export function TelemetryFlushMount() {
  useTelemetryFlush();
  return null;
}
